import React from "react";
import { SketchPicker } from "react-color";
import PopoverDropdown from "../../../../elements/PopoverDropdown";
import { classNames } from "../../../../../helpers/classNames";
import { useDispatch } from "react-redux";
import { setThemeValue } from "../../../../../redux/slice/themeSlice";
import { useSelector } from "react-redux";
import Tooltip from "../../../../elements/Tooltip";
import { hexToRgb, isValidColorCode, rgba } from "../../../../../helpers";

const ConfigsTool = () => {
  const dispatch = useDispatch();
  const { theme } = useSelector((state) => state?.themeProvider);

  function replaceWith(str) {
    return [
      { name: "bg", value: "Background color" },
      { name: "text", value: "Text color" },
      { name: "border", value: "Border color" },
      { name: "hover:bg", value: "Background color on hover" },
      { name: "hover:text", value: "Text color on hover" },
      { name: "hover:border", value: "Border color on hover" },
      { name: "normal:bg", value: "Background color on normal" },
      { name: "normal:text", value: "Text color on normal" },
      { name: "normal:border", value: "Border color on normal" },
    ]?.find((item) => str === item?.name)?.value;
  }

  function updateThemeSlice(val) {
    const { event, sec, key, color } = val;
    const newColorValue = event?.rgb;
    const updatedColors = JSON.parse(JSON.stringify(theme.colors));

    updatedColors[key][sec] = updatedColors[key][sec]?.map((item) => {
      const currentKey = Object.keys(item)[0];
      if (currentKey === color?.key) {
        return { [currentKey]: newColorValue };
      }
      return item;
    });

    dispatch(
      setThemeValue({
        colors: updatedColors,
      })
    );
  }

  return (
    <div>
      <div className="space-y-3">
        {Object.keys(theme?.colors)?.map((key, j) => (
          <div className="space-y-1" key={j?.toString()}>
            <span>{replaceWith(key)}</span>
            <div className="p-2 rounded-md border border-dashed border-gray-300">
              {Object.keys(theme?.colors[key])?.map((sec, i) => (
                <div className="space-y-1" key={i?.toString}>
                  <span>{replaceWith(`${sec}:${key}`)}</span>
                  <div className="flex items-center gap-1">
                    {theme?.colors[key][sec]?.map((color, k) => {
                      const value = Object.assign(
                        {},
                        ...Object?.entries(color)?.map(([key, value]) => ({
                          key,
                          value,
                        }))
                      );

                      return (
                        <Tooltip key={k?.toString()} message={value?.key}>
                          <PopoverDropdown
                            buttonLabel={
                              <div
                                className={classNames("w-full h-full bg-white")}
                              >
                                <div
                                  className="w-full h-full"
                                  style={{
                                    backgroundColor:
                                      isValidColorCode(value?.value) === "HEX"
                                        ? rgba(hexToRgb(value?.value))
                                        : rgba(value?.value),
                                  }}
                                >
                                  {!value?.value && (
                                    <span className="w-full h-full text-red-500">
                                      <i className="fa-regular fa-slash-forward"></i>
                                    </span>
                                  )}
                                </div>
                              </div>
                            }
                            buttonclassName={classNames(
                              "!border p-0 overflow-hidden !border-red-500/40 !bg-transparent w-8 h-8 hover:shadow-md hover:scale-[1.15] transition-all duration-150"
                            )}
                            contentclassName="!border-0 p-0 !min-w-fit bg-transparent editable-element not-changable"
                          >
                            <SketchPicker
                              className="!shadow-none !border-0"
                              color={value?.value}
                              onChange={(e) => {
                                updateThemeSlice({
                                  event: e,
                                  sec,
                                  key,
                                  color: value,
                                });
                              }}
                            />
                          </PopoverDropdown>
                        </Tooltip>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConfigsTool;
